import { render } from "./UserQuestionsView.vue?vue&type=template&id=1dce95e2&scoped=true"
import script from "./UserQuestionsView.vue?vue&type=script&lang=js"
export * from "./UserQuestionsView.vue?vue&type=script&lang=js"

import "./UserQuestionsView.vue?vue&type=style&index=0&id=1dce95e2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1dce95e2"]])

export default __exports__